import GET_SALES_PERIODS from './getSalesPeriods.graphql'

export { GET_SALES_PERIODS }
